import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    evaluacionesMedico: [],
    evaluacionesMedicoExpediente: [],
  },

  getters: {
    getEvaluacionesMedico: (state) => state.evaluacionesMedicoExpediente,

    getEvaluacionesMedicoAll: (state) => state.evaluacionesMedico,
  },

  mutations: {
    SET_EVALUACIONES_MEDICO(state, evaluacionesMedico) {
      state.evaluacionesMedico = evaluacionesMedico;
    },

    SET_EVALUACIONES_MEDICO_EXPEDIENTE(state, evaluacionesMedicoExpediente) {
      state.evaluacionesMedicoExpediente = evaluacionesMedicoExpediente;
    },
  },

  actions: {
    async fetchEvaluacionesMedico({ commit }) {
      axios
        .get('PoliciaCuadrantes/C3/evaluacionesMedico')
        .then((response) => {
          commit('SET_EVALUACIONES_MEDICO', response.data.data);
        });
    },

    async fetchEvaluacionesMedicoByExpediente({ commit }, idExpediente) {
      await axios
        .get(`PoliciaCuadrantes/C3/expedientes/${idExpediente}/evaluacionesMedico`)
        .then((response) => {
          commit('SET_EVALUACIONES_MEDICO_EXPEDIENTE', response.data.data);
        });
    },

    async saveEvaluacionMedico(context, evaluacionMedico) {
      await axios
        .post(`PoliciaCuadrantes/C3/expedientes/${evaluacionMedico.fk_idExpediente}/evaluacionesMedico`, evaluacionMedico);
    },

    async updateEvaluacionMedico(_, evaluacionMedico) {
      await axios
        .put(`PoliciaCuadrantes/C3/expedientes/${evaluacionMedico.fk_idExpediente}/evaluacionesMedico`, evaluacionMedico);
    },
  },
};
